import { render } from "./NotifyMessage.vue?vue&type=template&id=340e669c"
import script from "./NotifyMessage.vue?vue&type=script&lang=js"
export * from "./NotifyMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__